var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1987_29390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 8V14.6667H2.66699V8",
    stroke: "#2F1C0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 4.66675H1.33301V8.00008H14.6663V4.66675Z",
    stroke: "#2F1C0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6667V4.66675",
    stroke: "#2F1C0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 4.66659H4.99967C4.55765 4.66659 4.13372 4.49099 3.82116 4.17843C3.5086 3.86587 3.33301 3.44195 3.33301 2.99992C3.33301 2.55789 3.5086 2.13397 3.82116 1.82141C4.13372 1.50885 4.55765 1.33325 4.99967 1.33325C7.33301 1.33325 7.99967 4.66659 7.99967 4.66659Z",
    stroke: "#2F1C0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.66659H11C11.442 4.66659 11.866 4.49099 12.1785 4.17843C12.4911 3.86587 12.6667 3.44195 12.6667 2.99992C12.6667 2.55789 12.4911 2.13397 12.1785 1.82141C11.866 1.50885 11.442 1.33325 11 1.33325C8.66667 1.33325 8 4.66659 8 4.66659Z",
    stroke: "#2F1C0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1987_29390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayIcon);
export default __webpack_public_path__ + "static/media/birthdayIcon.1f36cf1880ddd6f81056de28650ad5f5.svg";
export { ForwardRef as ReactComponent };